export default "__VITE_ASSET__CnH0c4V6__"